<template>
    <u-btn-arrow-outlined-circle v-bind="{ color, ...$attrs }" @click="$emit('click')">
        <icon-arrow-primary v-bind="{ direction }" />
    </u-btn-arrow-outlined-circle>
</template>

<script>
import IconArrowPrimary from "@/components/publish/parents/icons/icon-arrow-primary.vue";
import UBtnArrowOutlinedCircle from "@/components/publish/styles/buttons/u-btn-arrow-outlined-circle.vue";

export default {
    props: {
        color: { type: String, default: "grey" },
        direction: { type: String, default: "left" },
    },
    components: {
        IconArrowPrimary,
        UBtnArrowOutlinedCircle,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
